import { render, staticRenderFns } from "./reCheckSecnario.vue?vue&type=template&id=486c67c4"
import script from "./reCheckSecnario.vue?vue&type=script&lang=js"
export * from "./reCheckSecnario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486c67c4')) {
      api.createRecord('486c67c4', component.options)
    } else {
      api.reload('486c67c4', component.options)
    }
    module.hot.accept("./reCheckSecnario.vue?vue&type=template&id=486c67c4", function () {
      api.rerender('486c67c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/reCheckSecnario.vue"
export default component.exports